import React from 'react';
import { Alert } from '@material-ui/lab';

import { GridItemRow, MessageLines } from '../blocks';
import { advisoryLines } from '../util/resourceCeilings';

// Shown in the submit modals rather than handleSubmitCheck, which the "Lock All Routes" path
// bypasses entirely. Every warning is continuable: nothing downstream refuses a route over a
// resource ceiling.
const CeilingWarnings = ({ warned, showRouteNames }) =>
    warned.length > 0 ? (
        <GridItemRow>
            <Alert severity="warning">
                <MessageLines lines={advisoryLines(warned, showRouteNames)} />
            </Alert>
        </GridItemRow>
    ) : null;

export default CeilingWarnings;
